// extracted by mini-css-extract-plugin
export default {"preloader":"preloader_preloader__duIWZ","preloader_image":"preloader_preloader_image__Xwwvi"};